// Ввод денежной суммы в формах: пользователи набирают копейки и через точку, и через запятую
// (вопрос заказчика от 2026-08-12). Разделитель приводим к точке, потому что на отправке значение
// проходит через parseFloat — «34,40» молча превратилось бы в 34, без ошибки и без копеек.

// Подсказка под полем суммы — единый текст для всех полей ввода суммы.
export const AMOUNT_HINT = 'Например: 34.40 (копейки указываются через точку)';

// Сообщение об ошибке формата — парное к amountFormat.
export const AMOUNT_FORMAT_ERROR = 'Только число, разделитель — точка';

// Запятая → точка; пробелы убираем (\s в JS покрывает и неразрывный — из копипаста «1 234,50»).
// Заменяется ПЕРВАЯ запятая: «1,234,50» останется невалидным, а не будет угадан.
export const normalizeAmountSeparator = (value: string | number | null | undefined): string => {
  if (value === null || value === undefined) return '';
  return String(value).replace(/\s/g, '').replace(',', '.');
};

// Неотрицательное число с любым числом знаков после разделителя (2 знака не навязываем:
// fill-by-ID кладёт в поле сумму листа учёта как есть). Пустое значение допустимо —
// за обязательность отвечает отдельный required, иначе под полем две ошибки сразу.
export const amountFormat = (value: string | number | null | undefined): boolean => {
  const normalized = normalizeAmountSeparator(value);
  if (normalized === '') return true;
  return /^\d+(\.\d+)?$/.test(normalized);
};

// Число для отправки на бэк. NaN для непарсимого значения — валидация такое к отправке не пускает.
export const parseAmount = (value: string | number | null | undefined): number => parseFloat(
  normalizeAmountSeparator(value),
);
